export const minRisksTableColumnsWidth = {
  paymentId: 150,
};
export const PROJECTS_LIMIT = 50;
